export const MoveDocumentIcon: React.FC<React.SVGProps<SVGSVGElement>> = (
  props,
) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
      {...props}
    >
      <path
        d="M21 5V1H3V23H21V19"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path d="M7 7H11" strokeLinecap="round" />
      <path d="M7 12H21M21 12L18 9M21 12L18 15" strokeLinecap="round" />
      <path d="M7 17H11" strokeLinecap="round" />
    </svg>
  );
};
